import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { DataTest, SchemaTestForm } from '@y42/data-test';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataTestConditionFormatterService } from './data-test-condition-formatter.service';

export interface DataTestConditionCellRendererInputParam {
  dataTest: DataTest | null;
  schemaTest: SchemaTestForm | null;
}

@UntilDestroy()
@Component({
  selector: 'y42-data-test-condition-cell-renderer',
  templateUrl: './data-test-condition-cell-renderer.component.html',
  styleUrls: ['./data-test-condition-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DataTestConditionFormatterService],
})
export class DataTestConditionCellRendererComponent implements ICellRendererAngularComp {
  constructor(private readonly dataTestConditionFormatterService: DataTestConditionFormatterService) {}

  private readonly value$$ = new BehaviorSubject<DataTestConditionCellRendererInputParam | null>(null);
  private readonly isGroup$$ = new BehaviorSubject<boolean>(false);

  readonly state = connectState(this, {
    conditionText: this.dataTestConditionFormatterService.getFormattedText(
      this.value$$.pipe(map((x) => x?.dataTest)),
      this.value$$.pipe(map((x) => x?.schemaTest)),
    ),
    expandToSee: this.isGroup$$,
  });

  agInit(params: ICellRendererParams<unknown, DataTestConditionCellRendererInputParam>): void {
    this.refreshData(params);
  }

  refresh(params: ICellRendererParams<unknown, DataTestConditionCellRendererInputParam>): boolean {
    this.refreshData(params);
    return true;
  }

  private refreshData(params: ICellRendererParams<unknown, DataTestConditionCellRendererInputParam>) {
    this.value$$.next(params.value ?? null);
    this.isGroup$$.next(params.node.group ?? false);
  }
}
